import { createActionTypeModel } from "../../../../store/global/action-model";

export const BOOKING_PLUGINS = createActionTypeModel("BOOKING_PLUGINS");
